module.exports = __webpack_public_path__ + "static/media/icon-circle-line.c260bdc5.svg";